import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferAppleMusicToYoutubeMusic() {
    return (
        <GuidesPage
            seoData={seoContent.transferAppleMusicToYoutubeMusic}
            sections={<PairTransferGuideContent sourceKey="appleMusic" destKey="youtubeMusic" />}
        />
    );
}
